import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormLink from '../../../../../library/form/components/FormLink';

const ProdIOOSumViewRow = (props) => {
    const { formObject, viewData, index, rowKey } = props;

    const rowCss = formObject.getValueFromKey(viewData, "dataList.cssClass", "");

    return (
        <ul className={`uiDPEditLine ${rowCss}`}>
            <li className="uiColumnCenter uiColumn30">
                <span>{index}</span>
            </li>
            <li className="uiColumn uiColumnLeft uiColumn90">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "id" }} />
            </li>
            <li className="uiColumnCenter uiColumn200">
                <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                    action={{ 
                        paramName: "actualItem", 
                        actionId: "show", actionName: "itemComp",
                        containerKey: "custom",
                        actionParam:{showModeID: "qv"} 
                    }}
                    linkProp={{ target: "_blank" }}
                ></FormLink>
            </li>
            <li className="uiColumnCenter uiColumn50">
                <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "units" }} />
            </li>
            <li className="uiColumnCenter uiColumnQty">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyRequired" }} />
            </li>
            <li className="uiColumnCenter uiColumnQty">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyAllocated" }} />
            </li>
            <li className="uiColumnCenter uiColumnQty">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyRequested" }} />
            </li>
            <li className="uiColumnCenter uiColumnQty">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyReceived" }} />
            </li>
            <li className="uiColumnCenter uiColumnQty">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyIssued" }} />
            </li>
            <li className="uiColumnCenter uiColumnQty">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyReturnedByWorker" }} />
            </li>
            <li className="uiColumnCenter uiColumnQty">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyConsumed" }} />
            </li>
            <li className="uiColumnCenter uiColumnQty">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyWasted" }} />
            </li>
            <li className="uiColumnCenter uiColumnQty">
                <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyBalance" }} />
            </li>
            <li className="uiColumnCenter uiColumnQty">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyReturnedToStock" }} />
            </li>
        </ul>
    )
}

export default ProdIOOSumViewRow